import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Amenities = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  // Array of images with src and alt
  const amenityImages = [
    { src: "images/2.PNG", alt: "Amenity 2" },
    { src: "images/3.PNG", alt: "Amenity 3" },
    { src: "images/4.PNG", alt: "Amenity 4" },
    { src: "images/5.PNG", alt: "Amenity 5" },
    { src: "images/10.PNG", alt: "Amenity 6" },
  ];

  return (
    <section className="section shadow-sm lazyloaded" id="Amenities">
      <span className="section-link"></span>{" "}
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">{project} - Amenities</h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto  d-none d-lg-block"
            onClick={() => handleShowModal("Download Amenities")}
          >
            Download Amenities
          </button>
        </div>
      </div>
      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        {amenityImages.map((image, index) => (
          <div
            key={index}
            // className="at-property-item"
          >
            <a
              data-fancybox="gallery-0"
              onClick={() => handleShowModal("Download Amenities")}
              // className="at-property-img"
            >
              <img
                data-src={`../${image.src}`}
                loading="lazy"
                className="gallery-thumb ls-is-cached lazyloaded"
                src={image.src}
                alt={image.alt}
              />
              {/* <div className="at-property-overlayer"></div>
              <span
                className="btn btn-default at-property-btn"
                role="button"
                onClick={handleShowModal}
              >
                View Amenities
              </span> */}
            </a>
          </div>
        ))}
      </div>
      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={() => handleShowModal("Download Amenities")}
        >
          Download Amenities
        </button>
      </div>
    </section>
  );
};

export default Amenities;
